import { fetcher } from "helpers/fetcher";

import { TGetIndeedCategoryReq, TGetIndeedCategoryRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getIndeedCategory = async (params: TGetIndeedCategoryReq) => {
  return await fetcher<TGetIndeedCategoryRes, TGetIndeedCategoryReq>(
    ENDPOINT.CORPORATION.GET_INDEED_CATEGORY,
    {
      params: params,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.CORPORATION.GET_INDEED_CATEGORY.version,
      },
    }
  );
};

export const queryGetIndeedCategory = async (params: TGetIndeedCategoryReq) => {
  return (await getIndeedCategory(params)).data;
};

queryGetIndeedCategory._key = (params: TGetIndeedCategoryReq, key?: string) => [
  ENDPOINT.CORPORATION.GET_INDEED_CATEGORY.url,
  params,
  key,
];
